﻿export function getFormattedPrice(myPrice, symbol, conversionRate) {
    var xPrice = parseFloat(myPrice);
    var formattedPrice = "";
    if (xPrice > 0) {
        formattedPrice = numberToCurrency(xPrice, symbol, conversionRate);
    }
    else {
        formattedPrice = "FREE";
    }
    return formattedPrice;
};

export function numberToCurrency(number, symbol, conversionRate) {
    return symbol + (number * conversionRate).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
};